"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Badge } from "@/components/ui/badge";
function BlogGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="flex flex-col gap-4 animate-pulse">
            <div className="w-full aspect-[16/10] bg-muted rounded-2xl" />
            <div className="h-4 w-24 bg-muted rounded-lg" />
            <div className="h-8 w-3/4 bg-muted rounded-lg" />
            <div className="h-4 w-20 bg-muted rounded-lg mt-2" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="text-center text-muted-foreground py-12 bg-card rounded-2xl border border-border/50">
        <p className="font-default">Er is een fout opgetreden bij het laden van de artikelen.</p>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="text-center text-muted-foreground py-12 bg-card rounded-2xl border border-border/50">
        <p className="font-default">Er zijn momenteel geen nieuwe blogberichten beschikbaar.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {posts.map((post, i) => <article key={post.id} data-index={i} className="flex flex-col group transition-all duration-500 ease-in-out-expo hover:scale-[1.02] bg-card border border-muted/20 rounded-2xl shadow-xl overflow-hidden">
          <Link to={post.link || "#"} className="block overflow-hidden">
            <img src={post.featuredImage} alt={post.title} loading="lazy" decoding="async" className="w-full aspect-[16/10] object-cover grayscale-[20%] contrast-[1.05] transition-transform duration-700 group-hover:scale-110" />
          </Link>
          <div className="flex flex-col flex-grow p-8">
            <div className="flex items-center justify-between mb-3">
              <span className="text-[10px] text-primary font-mono uppercase tracking-[0.2em] font-bold">
                {post.date ? new Date(post.date).toLocaleDateString('nl-NL', {
              day: 'numeric',
              month: 'long',
              year: 'numeric'
            }) : "Update"}
              </span>
              {post.categories && post.categories.length > 0 && <Badge variant="default" className="bg-primary text-primary-foreground text-[10px] uppercase tracking-wider rounded-lg">
                  {post.categories[0].name}
                </Badge>}
            </div>
            <Link to={post.link || "#"} className="block mb-3">
              <h3 className="text-2xl font-serif font-bold text-foreground group-hover:text-primary transition-colors line-clamp-2 tracking-tighter leading-tight">
                {post.title}
              </h3>
            </Link>
            {post.excerpt && <div className="text-muted-foreground text-sm line-clamp-3 mb-4 font-default leading-relaxed" dangerouslySetInnerHTML={{
          __html: post.excerpt
        }} />}
            <div className="mt-auto pt-4">
              <Link to={post.link || "#"} className="inline-flex items-center gap-2 font-sans font-bold text-secondary hover:text-secondary/80 transition-colors group/link">
                <span className="text-sm uppercase tracking-wider">Lees Meer</span>
                <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover/link:translate-x-1" />
              </Link>
            </div>
          </div>
        </article>)}
    </div>;
}
export default function LatestSecurityInsights() {
  const wp_query_params = {
    post_type: "post",
    per_page: 3,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="223439" id="latest-blog-posts" className="bg-background text-foreground py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-16 flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div className="max-w-2xl">
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-foreground mb-6 tracking-tighter">
              Local Ottawa Insights: <span className="text-primary">Junk Removal Tips & Tricks</span>
            </h2>
            <p className="text-muted-foreground font-default text-lg leading-relaxed">
              Blijf op de hoogte van de laatste ontwikkelingen in duurzame afvalverwerking en slimme opruimoplossingen in de regio Ottawa.
            </p>
          </div>
          <Link to="/BlogPage" className="hidden md:inline-flex items-center gap-2 font-sans font-bold text-foreground hover:text-primary transition-colors border-b-2 border-primary pb-1">
            Bekijk alle artikelen <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        
        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 3,
        orderby: "date",
        order: "desc"
      }}>
          <BlogGridConsumer />
        </PostsProvider>

        <div className="mt-12 md:hidden text-center">
          <Link to="/BlogPage" className="inline-flex items-center gap-2 font-sans font-bold text-secondary">
            Bekijk alle artikelen <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>;
}